// Каталог уровней игроков (UX-вайрфрейм, экран 09) — стаб до M4 UGC.
// Вкладка навбара уже живёт, лента появится вместе с мастерской.

import { BottomNav } from '@/meta/Shell';

export function CatalogScreen() {
  return (
    <main className="meta-screen" data-testid="screen-catalog">
      <header className="meta-subbar">
        <h1>Каталог уровней игроков</h1>
      </header>
      <div className="meta-body">
        <div className="stub-frame">
          <span aria-hidden="true" style={{ fontSize: 40 }}>📁</span>
          <h2>Скоро здесь будут уровни игроков</h2>
          <p>
            Лента уровней из мастерских: превью, автор, сложность — и запуск в один тап.
            Откроется вместе с мастерской.
          </p>
        </div>
      </div>
      <BottomNav />
    </main>
  );
}
